import { useEffect, useState } from "react";

import { apiClient } from "~/api/ApiClient";
import { tryCatch } from "~/helpers/tryCatch";

type Options = {
  token: string | null;
  alliaiapp: boolean;
  setToken: (token: string) => void;
};

export type SsoStatus = "idle" | "pending" | "denied" | "done";

export function useSso({ alliaiapp, token, setToken }: Options) {
  const [status, setStatus] = useState<SsoStatus>("idle");

  useEffect(() => {
    if (token) {
      setStatus("done");

      return;
    }

    if (!alliaiapp) return;

    let cancelled = false;

    const run = async () => {
      setStatus("pending");

      try {
        const { data, error } = await tryCatch(
          apiClient.session.postSession({ credentials: "include" }),
        );

        if (cancelled) return;

        if (error) {
          setStatus("denied");

          return;
        }

        const tokenKey = data.data.access_token.key;
        setToken(tokenKey);
        setStatus("done");
      } catch {
        if (!cancelled) setStatus("denied");
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [token, alliaiapp, setToken]);

  return { status };
}
